import { BRANDS_API_URL, DESIGNERS_API_URL } from '../constants/endpoints';

export const fetchBrandData = () => {
  const method = 'GET';
  const headers = new window.Headers();
  const url = BRANDS_API_URL;

  headers.append('Accept', 'application/json');

  const options = {
    headers,
    method
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error();
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};

export const fetchDesignerData = () => {
  const method = 'GET';
  const headers = new window.Headers();
  const url = DESIGNERS_API_URL;

  headers.append('Accept', 'application/json');

  const options = {
    headers,
    method
  };

  return window
    .fetch(url, options)
    .then(response => {
      if (response.ok) {
        return response.json();
      }
      return response.error();
    })
    .then(json => json)
    .catch(error => {
      throw error;
    });
};



// WEBPACK FOOTER //
// ./src/api/cmsBrandApi.js